import { useStateValue } from "../context/StateValueContext";
import { hasPermission } from "../functions/permissionUtils";
import { PERMISSIONS } from "../constants/permissions";

export type DisputesAccess = "visible" | "hidden" | "loading" | "error";

// Clients default to hidden until their settings resolve (disputesEnabled === null),
// so dispute surfaces never flash before we know whether the company is gated.
// "error" means the settings fetch failed and the answer is unknowable without a retry.
// Admins/agents (DISPUTES_ALL_COMPANIES) are always visible and never fetch settings.
export function useDisputesAccess(): DisputesAccess {
  const [{ user, disputesEnabled, companySettingsFailed }] = useStateValue();
  if (hasPermission(user, PERMISSIONS.DISPUTES_ALL_COMPANIES)) return "visible";
  if (companySettingsFailed) return "error";
  if (disputesEnabled === null) return "loading";
  return disputesEnabled ? "visible" : "hidden";
}

// Convenience for surfaces that simply hide while loading (nav item, dashboard metrics).
// The disputes route uses useDisputesAccess directly so it can wait rather than redirect.
export function useDisputesVisible(): boolean {
  return useDisputesAccess() === "visible";
}
